import React, { useEffect, useRef, useState } from 'react'
import styles from './AppointmentBar.module.css';
import data from '../../appointments.json';


// const DOCTORS = data?.bookAppointment?.doctors?.map((d) => ({
//   label: d.name,
//   sub: `${d.role} · ${d.experience}`,
//   specialities: d.speciality ? [d.speciality] : [],
//   location: d.locations[0]?.label,
//   original: d,
// }));


const rawDoctors = data?.bookAppointment?.doctors ?? [];

// ── derived from JSON ──────────────────────────────────────
const DOCTORS = rawDoctors.map((d) => ({
  label: d.name,
  sub: `${d.role} · ${d.experience}`,
  specialities: d.speciality ? [d.speciality] : [],
  location: d.locations?.[0]?.label,
  original: d,
}));

const SPECIALITIES = [
  ...new Map(
    rawDoctors
      .filter((d) => d.speciality)
      .map((d) => [d.speciality, { label: d.speciality }])
  ).values(),
];

const LOCATIONS = [
  ...new Map(
    rawDoctors
      .flatMap((d) => d.locations ?? [])
      .map((l) => [l.label, { label: l.label }])
  ).values(),
];
function Segment({ label, value, placeholder, children, isOpen, onToggle }) {
    return (
        <div className={`${styles.seg} ${isOpen ? styles.segOpen : ""}`} onClick={onToggle}>
            {/* <span className={styles.segLabel}>{label}</span> */}
            <div className={styles.segValueRow}>
                <span className={`${styles.segValue} ${!value ? styles.placeholder : ""}`}>
                    {value || placeholder}
                </span>
                <svg className={styles.chevron} viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2.5">
                    <polyline points="6 9 12 15 18 9" />
                </svg>
            </div>
            {children}
        </div>
    );
}
function Dropdown({ items, selected, onSelect, searchable, align = 'left' }) {
    const [query, setQuery] = useState("");
    const filtered = items.filter((d) => d.label.toLowerCase().includes(query.toLowerCase()));
    
    return (
        <div className={`${styles.dropdown} ${align === 'right' ? styles.dropdown : ""}`}
            onClick={(e) => e.stopPropagation()}
        >
            {searchable && (
                <div className={styles.searchBox}>
                    <input
                        autoFocus
                        placeholder="Search..."
                        value={query}
                        onChange={(e) => setQuery(e.target.value)}
                        className={styles.searchInput}
                    />
                </div>
            )}
            <div className={styles.optList}>
                {filtered.length === 0 ? (
                    <div className={styles.noResults}>No results found</div>
                ) : (
                    filtered.map((d) => (
                        <div
                            key={d.label}
                            className={`${styles.opt} ${selected === d.label ? styles.optActive : ""}`}
                            onClick={() => onSelect(d.label)}
                        >
                            <div>
                                <div className={styles.optLabel}>{d.label}</div>
                                {d.sub && <div className={styles.optSub}>{d.sub}</div>}
                            </div>
                        </div>
                    ))
                )}
            </div>

        </div>
    )
}

export default function AppointmentBar({ onBook }) {
    const [open, setOpen] = useState(null); // 'spec' | 'loc' | 'doc'
    const [spec, setSpec] = useState(null);
    const [loc, setLoc] = useState(null);
    const [doc, setDoc] = useState(null);
    const barRef = useRef(null); 
    const [errors, setErrors] = useState({}); 

    useEffect(() => {
        const handler = (e) => {
            if (barRef.current && !barRef.current.contains(e.target)) setOpen(null);
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);
    const filteredDoctors = DOCTORS.filter((d) => {
  const matchSpec = !spec || d.specialities.includes(spec);
  const matchLoc  = !loc  || d.location === loc;   // === instead of .includes()
  return matchSpec && matchLoc;
});
    const toggle = (key) => setOpen((prev) => (prev === key ? null : key));
// in AppointmentBar
// const handleBook = () => {
//   const fullDoc = DOCTORS.find((d) => d.label === doc)?.original ?? null;
//   onBook?.({ speciality: spec, location: loc, doctor: doc, doctorData: fullDoc });
// };
   const handleBook = () => {
        // ← validate all three fields
        const newErrors = {};
        if (!spec) newErrors.spec = "Please select a speciality";
        if (!loc)  newErrors.loc  = "Please select a location";
        if (!doc)  newErrors.doc  = "Please select a doctor";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            return;   // ← stop here, don't call onBook
        }

        setErrors({});
        const fullDoc = DOCTORS.find((d) => d.label === doc)?.original ?? null;
        onBook?.({ speciality: spec, location: loc, doctor: doc, doctorData: fullDoc });
    };
    return (
        <div className={styles.bar} ref={barRef}>
            <Segment
                label="Select speciality"
                value={spec}
                placeholder="Select speciality"
                isOpen={open === "spec"}
                onToggle={() => toggle("spec")}
            >
                {open === "spec" && (
                    <Dropdown
                        items={SPECIALITIES}
                        selected={spec}
                        onSelect={(v) => { setSpec(v); setOpen(null);setDoc(null); }}
                        searchable
                    />
                )}
            </Segment>

            <Segment
                label="Select location"
                value={loc}
                placeholder="Select location"
                isOpen={open === "loc"}
                onToggle={() => toggle("loc")}
            >
                {open === "loc" && (
                    <Dropdown
                        items={LOCATIONS}
                        selected={loc}
                        onSelect={(v) => { setLoc(v); setOpen(null);setDoc(null); }}
                    />
                )}
            </Segment>

            <Segment
                label="Select a doctor"
                value={doc}
                placeholder="Select a doctor"
                isOpen={open === "doc"}
                onToggle={() => toggle("doc")}
            >
                {open === "doc" && (
                    <Dropdown
                        items={filteredDoctors}
                        selected={doc}
                        onSelect={(v) => { setDoc(v); setOpen(null); }}
                        searchable
                        align="right"
                    />
                )}
            </Segment>

            <button className={styles.bookBtn} onClick={handleBook}
             disabled={!spec || !loc || !doc}>
                Book An Appointment
            </button>
            
        </div>
    );
}
